import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        account_id          : 0,
        segment_name        : '',
        segment_description : '',
        segment_condition   : '',
        segment_type        : 0,
        count_user          : 0,
        created_by          : 0,
        created_at          : 0,
        edited_at           : 0,
        count_updated_at    : 0,
        is_archived         : false
    }
});